import { get } from "../../utils/object-helpers";

$ {
    const filterLabel = get(input, 'sortItemsSelection.label.textSpans.[0].text', '');
    const title = get(input, 'title.textSpans.[0].text', '');
}

<if(filterLabel)>
    <div class="str-sort">
        <label><span>${filterLabel}</span>
            <div class="str-sort__button-wrap">
                <ebay-menu-button text=state.selectedText reverse on-change("sortListings") type="radio">
                    <for|option| of=state.options>
                        <@item data-url=JSON.stringify(option.action.URL) checked=option.selected data-testid=("sort-"+option.action.params._sop)>
                            ${option.text}
                        </@item>
                    </for>
                </ebay-menu-button>
                <if(title)>
                    <span class="clipped"> - ${state.selectedText}</span>
                </if>
            </div>
        </label>
    </div>
</if>
